export type Person = 'Patrick' | 'Prapti';

export type Status = 'todo' | 'in-progress' | 'done';

export type Recurrence = 'none' | 'daily' | 'weekly' | 'biweekly' | 'monthly' | 'unspecified';

export const PROJECT_COLORS: string[] = [
  '#5b8def', // blue
  '#9b6bff', // purple
  '#2dd4bf', // teal
  '#ff9f43', // orange
  '#ff6b9f', // pink
  '#4ade80', // green
  '#eab308', // yellow
  '#38bdf8' // cyan
];

export interface Project {
  id: string;
  title: string;
  description?: string;
  color: string;
  createdAt: string;
  updatedAt: string;
}

export interface HouseholdItem {
  id: string;
  title: string;
  description?: string;
  status: Status;
  assignee?: Person;
  dueDate?: string; // YYYY-MM-DD
  effort?: number; // 1-5, optional difficulty/effort score
  recurrence: Recurrence;
  projectId?: string; // grouping under a Project, optional
  createdAt: string;
  updatedAt: string;
}

export interface Completion {
  id: string;
  itemId: string;
  title: string;
  assignee: Person;
  effort?: number;
  completedAt: string;
}

export interface HouseholdData {
  projects: Project[];
  items: HouseholdItem[];
  completions: Completion[];
}

export const PEOPLE: Person[] = ['Patrick', 'Prapti'];

export const RECURRENCE_LABELS: Record<Recurrence, string> = {
  none: 'One-off',
  daily: 'Daily',
  weekly: 'Weekly',
  biweekly: 'Every 2 weeks',
  monthly: 'Monthly',
  unspecified: 'Repeats (no fixed date)',
};

export const STATUS_LABELS: Record<Status, string> = {
  todo: 'To Do',
  'in-progress': 'In Progress',
  done: 'Done',
};
